import React from 'react';

import { Typography } from '@/components/atoms/Typography';

export interface Props {
  primaryTitle: string;
  primaryCaption: string;
  primaryImage: string;
  secondaryTitle: string;
  secondaryCaption1: string;
  secondaryCaption2: string;
  thirdTitle: string;
  thirdCaption: string;
  thirdImage: string;
  fourthTitle: string;
  fourthCaption: string;
  fourthImage: string;
}

export const BentoGrid = ({
  primaryTitle,
  primaryCaption,
  primaryImage,
  secondaryTitle,
  secondaryCaption1,
  secondaryCaption2,
  thirdTitle,
  thirdCaption,
  thirdImage,
  fourthTitle,
  fourthCaption,
  fourthImage
}: Props) => {
  return (
    <div className="flex gap-3 md:gap-5 flex-col p-4 md:flex-row justify-center">
      <div className="bg-slate-100/80 p-8 flex flex-col justify-center items-center gap-2 rounded-xl">
        <Typography tag="p" variant="h3" weight="semibold" align="center" color="primary">
          {primaryTitle}
        </Typography>
        <img alt={primaryCaption} width={400} height={200} src={primaryImage} />
        <Typography tag="p" variant="paragraph" align="center" color="gray">
          {primaryCaption}
        </Typography>
      </div>
      <div className="flex flex-col gap-3 md:gap-5 max-w-sm">
        <div className="bg-slate-100/80 p-5 h-full rounded-xl justify-center items-center flex flex-col">
          <Typography tag="p" variant="h3" weight="semibold" align="center" color="gray">
            {secondaryTitle}
          </Typography>
          <span className="mt-3 flex gap-1 items-center">
            <Typography tag="p" variant="h5" align="center" color="primary">
              <span className="border border-red-300 rounded-full py-0.5 px-2 mr-1.5"> {secondaryCaption1}</span>
              {secondaryCaption2}
            </Typography>
          </span>
        </div>
        <div className="bg-slate-100/80 rounded-xl h-full px-2">
          <div className="px-8 pt-8 pb-3 flex flex-col gap-3">
            <Typography tag="p" variant="h3" weight="semibold" align="center" color="gray">
              {thirdTitle}
            </Typography>
            <Typography tag="p" variant="h5" align="center" color="primary">
              {thirdCaption}
            </Typography>
          </div>
          <img alt={thirdCaption} width={350} height={200} src={thirdImage} />
        </div>
      </div>
      <div className="bg-slate-100/80 p-8 flex flex-col justify-center items-center gap-2 rounded-xl">
        <div className="max-w-sm gap-2 flex flex-col">
          <Typography tag="p" variant="h3" weight="semibold" align="center" color="gray">
            {fourthTitle}
          </Typography>
          <Typography tag="p" variant="h5" align="center" color="primary">
            {fourthCaption}
          </Typography>
        </div>
        <img alt={fourthCaption} width={300} height={200} src={fourthImage} />
      </div>
    </div>
  );
};
